export const REPORT_CONTENT_CLASSNAME =
    'text-justify prose prose-sm max-w-none prose-p:my-3 prose-headings:my-2 prose-ul:list-disc prose-ol:list-decimal prose-ul:pl-6 prose-ol:pl-6 [&_p]:!text-justify [&_li]:!text-justify';

export const REPORT_CONTENT_WRAPPER_CLASSNAME = 'text-slate-700 text-sm leading-relaxed';

// Text blocks (and table descriptions) render prose whose first/last paragraph carries a
// `my-3` margin. That margin sits inside the block and pushes its visible text off the shared
// 20px (`space-y-5`) grid, so text-adjacent gaps look bigger than chart/divider gaps. Zeroing
// the leading/trailing prose margin realigns every block type's content to the same 20px gap.
// The pagination splitter's measurement container must apply this too, or fragment heights
// disagree with the real page render.
export const BLOCK_TEXT_SPACING_RESET =
    '[&_.prose>*:first-child]:!mt-0 [&_.prose>*:last-child]:!mb-0';

// O rail de ações da tabela duplica o que o BlockActionsPanel já oferece com rótulo escrito
// (gráfico, IA, excluir) e é o chrome de hover mais pesado da página. Desligado para medir se
// a tabela fica mais legível sem ele; volte para `true` para restaurar o rail nas tabelas.
export const SHOW_TABLE_BLOCK_RAIL = false;
